import React from "react";
import "../../../styles/contactos.css";
import site from "../../../imgs/Icons/site.svg";
import tel from "../../../imgs/Icons/tel.svg";
import fax from "../../../imgs/Icons/fax.svg";
import email from "../../../imgs/Icons/email.svg";
import morada from "../../../imgs/Icons/morada.svg";
import { withNamespaces } from "react-i18next";

const OrgaosUA = ({ t }) => {

  const formatPhoneValues = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return `+351 ${phoneNumber.slice(0, 3)} 
  ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
  }

  return (
    <>
      <div className="accordion accordions_margin" id="accordionExample_orgaos">
        {/* 1 - REITORIA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="reitoria">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cReitoria"
              aria-expanded="true"
              aria-controls="cReitoria"
            >
              {t('moduleContactosEstruturas:S1.A.A1.T')}
            </button>
          </h2>
          <div
            id="cReitoria"
            className="accordion-collapse collapse"
            aria-labelledby="reitoria"
            data-bs-parent="#accordionExample_orgaos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p className="p-bold">
                {t('moduleContactosEstruturas:S1.A.A1.ST1.ST')}
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEstruturas:S1.A.A1.ST1.P1')}
                  >
                    {t('moduleContactosEstruturas:S1.A.A1.ST1.P1')}
                  </a>
                </p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S1.A.A1.ST1.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S1.A.A1.ST1.P2'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S1.A.A1.ST1.P3')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S1.A.A1.ST1.P3'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S1.A.A1.ST1.P4')}>
                  {t('moduleContactosEstruturas:S1.A.A1.ST1.P4')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>
                  {t('moduleContactosEstruturas:S1.A.A1.ST1.P5')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 2 - CONSELHO GERAL */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="conselhoG">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cConselhoG"
              aria-expanded="true"
              aria-controls="cConselhoG"
            >
              {t('moduleContactosEstruturas:S1.A.A2.T')}
            </button>
          </h2>
          <div
            id="cConselhoG"
            className="accordion-collapse collapse"
            aria-labelledby="conselhoG"
            data-bs-parent="#accordionExample_orgaos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S1.A.A2.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S1.A.A2.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S1.A.A2.P2')}>
                  {t('moduleContactosEstruturas:S1.A.A2.P2')}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 3 - CONSELHO CIENTIFICO */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="conselhoC">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cConselhoC"
              aria-expanded="true"
              aria-controls="cConselhoC"
            >
              {t('moduleContactosEstruturas:S1.A.A3.T')}
            </button>
          </h2>
          <div
            id="cConselhoC"
            className="accordion-collapse collapse"
            aria-labelledby="conselhoC"
            data-bs-parent="#accordionExample_orgaos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>{t('moduleContactosEstruturas:S1.A.A3.P1')}</p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S1.A.A3.P2')}>
                  {t('moduleContactosEstruturas:S1.A.A3.P2')}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 4 - CONSELHO PEDAGÓGICO */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="conselhoP">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cConselhoP"
              aria-expanded="true"
              aria-controls="cConselhoP"
            >
              {t('moduleContactosEstruturas:S1.A.A4.T')}
            </button>
          </h2>
          <div
            id="cConselhoP"
            className="accordion-collapse collapse"
            aria-labelledby="conselhoP"
            data-bs-parent="#accordionExample_orgaos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" href={"tel:+351" +
                    t('moduleContactosEstruturas:S1.A.A4.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S1.A.A4.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S1.A.A4.P2')}>
                  {t('moduleContactosEstruturas:S1.A.A4.P2')}
                  </a>
                </p>
                <p className="p-bold marginT-p">{t('moduleContactosEstruturas:S1.A.A4.ST1.ST')}</p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S1.A.A4.ST1.P1')}>
                  {t('moduleContactosEstruturas:S1.A.A4.ST1.P1')}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 5 - PROVEDOR DO ESTUDANTE */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="provedor">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cProvedor"
              aria-expanded="true"
              aria-controls="cProvedor"
            >
              {t('moduleContactosEstruturas:S1.A.A5.T')}
            </button>
          </h2>
          <div
            id="cProvedor"
            className="accordion-collapse collapse"
            aria-labelledby="provedor"
            data-bs-parent="#accordionExample_orgaos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">

                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a
                    className="link"
                    rel="noreferrer"
                    href={"tel:+351" +
                    t('moduleContactosEstruturas:S1.A.A5.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S1.A.A5.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S1.A.A5.P2')}>
                  {t('moduleContactosEstruturas:S1.A.A5.P2')}
                  </a>
                </p>

              </div>
            </div>
          </div>
        </div>
        {/* 6 - ADMINISTRAÇÃO */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="administracao">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cAdministracao"
              aria-expanded="true"
              aria-controls="cAdministracao"
            >
              {t('moduleContactosEstruturas:S1.A.A6.T')}
            </button>
          </h2>
          <div
            id="cAdministracao"
            className="accordion-collapse collapse"
            aria-labelledby="administracao"
            data-bs-parent="#accordionExample_orgaos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S1.A.A6.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S1.A.A6.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S1.A.A6.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S1.A.A6.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S1.A.A6.P3')}>
                  {t('moduleContactosEstruturas:S1.A.A6.P3')}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces()(OrgaosUA);
